webpackJsonp([263384032804510],{

/***/ 193:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(4);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _View = __webpack_require__(7);
	
	var _View2 = _interopRequireDefault(_View);
	
	var _PostsListView = __webpack_require__(15);
	
	var _PostsListView2 = _interopRequireDefault(_PostsListView);
	
	var _ContactView = __webpack_require__(5);
	
	var _ContactView2 = _interopRequireDefault(_ContactView);
	
	var _FooterView = __webpack_require__(6);
	
	var _FooterView2 = _interopRequireDefault(_FooterView);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var IndexPage = function IndexPage(props) {
	  var data = props.data;
	
	  var filters = [{
	    title: 'Technologie',
	    value: 'technologie'
	  }, {
	    title: 'Vie de l\'agence',
	    value: 'vie-de-l-agence'
	  }, {
	    title: 'Nos clients',
	    value: 'nos-clients'
	  }];
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_reactHelmet2.default, {
	      title: 'Blog : Nos clients - Com des L\xE9zards'
	    }),
	    _react2.default.createElement(
	      _View2.default,
	      { colorMode: '3' },
	      _react2.default.createElement(_PostsListView2.default, {
	        data: data,
	        title: 'Nous partageons avec vous',
	        titleColor: '#dedee3',
	        subtitle: 'Derniers articles',
	        subtitleColor: '#4d12c7',
	        activeFilter: 'nos-clients',
	        filters: filters
	      }),
	      _react2.default.createElement(_ContactView2.default, null),
	      _react2.default.createElement(_FooterView2.default, null)
	    )
	  );
	};
	
	exports.default = IndexPage;
	var query = exports.query = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-blog-nos-clients-jsx-3efda8b7d97b6290132c.js